export const PLAYER_PROFILE_STORAGE_KEY = 'towerarena.com.player-profile';
export const MAX_PLAYER_NAME_LENGTH = 20;

export interface PlayerProfile {
  schemaVersion: 2;
  displayName: string | null;
}

export function normalizePlayerName(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const normalized = value
    .normalize('NFKC')
    .replace(/[\p{Cc}\p{Cf}]/gu, '')
    .replace(/\s+/gu, ' ')
    .trim();
  if (!normalized) return null;
  const segments = typeof Intl.Segmenter === 'function'
    ? [...new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(normalized)].map((segment) => segment.segment)
    : Array.from(normalized);
  return segments.slice(0, MAX_PLAYER_NAME_LENGTH).join('') || null;
}

export function parsePlayerProfile(raw: string | null): PlayerProfile {
  if (!raw) return { schemaVersion: 2, displayName: null };
  try {
    const value = JSON.parse(raw) as Record<string, unknown>;
    const normalized = normalizePlayerName(value.displayName);
    return { schemaVersion: 2, displayName: normalized === 'Игрок' && value.schemaVersion === 1 ? null : normalized };
  } catch {
    return { schemaVersion: 2, displayName: null };
  }
}

export function savePlayerProfile(storage: Pick<Storage, 'setItem'>, profile: PlayerProfile): boolean {
  try {
    storage.setItem(PLAYER_PROFILE_STORAGE_KEY, JSON.stringify(profile));
    return true;
  } catch {
    return false;
  }
}
